import { ServiceSelection } from '../../types/planningTypes';

export const SCAFFOLD_HYMN_SLOTS: { placement: string; count: number }[] = [
  { placement: 'Opening Hymn', count: 1 },
  { placement: 'Offertory Anthem', count: 1 },
  { placement: 'Offertory Hymn', count: 1 },
  { placement: 'Communion', count: 2 },
  { placement: 'Closing Hymn', count: 1 },
];

export const buildMissingScaffoldRows = (
  serviceId: number,
  existing: ServiceSelection[],
): ServiceSelection[] => {
  const norm = (s: string | undefined) => (s || '').trim().toLowerCase();
  const existingCounts = new Map<string, number>();
  for (const sel of existing) {
    const key = norm(sel.placement);
    existingCounts.set(key, (existingCounts.get(key) || 0) + 1);
  }
  const newRows: ServiceSelection[] = [];
  for (const { placement, count } of SCAFFOLD_HYMN_SLOTS) {
    const have = existingCounts.get(norm(placement)) || 0;
    for (let i = 0; i < Math.max(count - have, 0); i++) {
      newRows.push({
        service_id: serviceId,
        placement,
        order_number: 0,
        song_title: '',
        performance_type: 'Congregational Hymn',
      });
    }
  }
  return newRows;
};

const LITURGICAL_ORDER: Record<string, number> = {
  'prelude': 10,
  'opening': 30,
  'opening hymn': 30,
  'kyrie': 40,
  'gloria': 50,
  'psalm': 60,
  'psalm refrain': 60,
  'gospel': 70,
  'gospel acclamation': 70,
  'creed': 80,
  'post sermon': 90,
  'asperges': 95,
  'offertory anthem': 100,
  'offertory': 110,
  'offertory hymn': 110,
  'sanctus': 120,
  "lord's prayer": 130,
  "the lord's prayer": 130,
  'fraction': 140,
  'communion': 150,
  'closing': 160,
  'closing hymn': 160,
};

const UNKNOWN_RANK = 999;

const rankOf = (placement: string | undefined): number => {
  const key = (placement || '').trim().toLowerCase();
  return LITURGICAL_ORDER[key] ?? UNKNOWN_RANK;
};

export const sortByLiturgy = (selections: ServiceSelection[]): ServiceSelection[] => {
  const withIndex = selections.map((s, i) => ({ s, originalIndex: i }));
  withIndex.sort((a, b) => {
    const rankDiff = rankOf(a.s.placement) - rankOf(b.s.placement);
    if (rankDiff !== 0) return rankDiff;
    return a.originalIndex - b.originalIndex;
  });
  return withIndex.map(({ s }, i) => ({ ...s, order_number: i + 1 }));
};
